import axios from "axios";
import Cookies from "js-cookie";

export const http2 = axios.create({
  baseURL: "https://api.dezignshark.com",
  // baseURL: "http2://localhost:8081",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",  
  }, 
}); 

http2.interceptors.request.use((config) => {
  const token = Cookies.get("access_token");  
  if (token) {    
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  }

  return config;
});

http2.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    if (err.message === "Network Error") {
      alert("Network Error");
    } else if (err.response.status === 401) {
      Cookies.remove("access_token");
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
